import { Component, OnInit, Renderer2, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OwnerInfoService } from 'src/app/service/owner-info/owner-info.service';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { StatesService } from 'src/app/service/states/states.service';
import { DOCUMENT } from '@angular/common';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
import { ProjectIndustryService } from 'src/app/service/project-industry/project-industry.service';
import { JobPointeService } from 'src/app/service/job-pointe/job-pointe.service';
import { MomentService } from 'src/app/service/shared/moment/moment.service';
import { ToastService } from 'src/app/service/shared/toast/toast.service';
import { BehaviorSubject } from 'rxjs';

export class ownerInfo {
  facility_name: string;
  street_address: string;
  apartment: string;
  city: string;
  state: string;
  zipcode: string;
  code: string;
  id: string;
}

@Component({
  selector: 'app-add-edit-owner-info',
  templateUrl: './add-edit-owner-info.component.html',
  styleUrls: ['./add-edit-owner-info.component.scss'],
})
export class AddEditOwnerInfoComponent implements OnInit {
  id;
  noDataMsg = '';
  ownerInfoForm: FormGroup;
  ownerName = '';
  projectIndustryType = 0;
  ownerInfoForForm: ownerInfo[] = [];
  statesData = [];
  projectIndustryData;
  facilityCerts: any = {};
  certificates = [];
  certsPage = 0;
  applyToAll: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private ownerInfoService: OwnerInfoService,
    private formBuilder: FormBuilder,
    private router: Router,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private _document,
    private statesServices: StatesService,
    private projectIndustryService: ProjectIndustryService,
    private jobpointeService: JobPointeService,
    private toastService: ToastService,
    private momentService: MomentService,
    private loaderService: LoaderService,
  ) {
    this.id = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit(): void {
    this.initializeForms();

    if (this.id != null && this.id != 0 && this.id != undefined && this.id != '') {
      this.loaderService.displayLoader();
      this.getOwnerInfo();
    }
    this.getStates();
    this.getProjectIndustry();
    this.getCerts();
  }

  loadSelect2() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  //Initialize owner info form
  initializeForms(data = null) {
    this.ownerInfoForm = this.formBuilder.group({
      facility_: this.formBuilder.array([this.addAdditionalInfoRows(data)]),
    });
  }

  // Add additional data in owner info form
  addAdditionalInfoRows(data = null) {
    /* Add new rows to existing dates */
    let group;
    group = this.formBuilder.group({
      indifacility: this.formBuilder.array([]),
    });

    //If data exist, set data in owner info form
    if (data != null) {
      data.forEach((element, index) => {
        this.addAdditionalInfoSameEditTime(group.controls.indifacility, element);
      });
    } else {
      this.addAdditionalInfoSameEditTime(group.controls.indifacility, data);
    }

    return group;
  }

  getMatchingAttr(attr) {
    return this.facilityCerts?.certifications?.find(cert => cert.jobBoardAttributeId === attr.id);
  }

  setCertExpirationDate(attr, expirationDate) {
    let cert = this.facilityCerts?.certifications?.find(cert => cert.jobBoardAttributeId === attr.id);
    if (cert) {
      cert.expirationDate = this.formatDate(expirationDate, 'YYYY-MM-DD');
    } else {
      this.facilityCerts.certifications.push({
        facilityId: this.facilityCerts.facility.id,
        jobBoardAttributeId: attr.id,
        expirationDate: this.formatDate(expirationDate, 'YYYY-MM-DD'),
      });
    }
  }

  setCertStatus(attr, status) {
    let cert = this.facilityCerts?.certifications?.find(cert => cert.jobBoardAttributeId === attr.id);
    if (cert) {
      cert.status = status;
    } else {
      this.facilityCerts.certifications.push({
        facilityId: this.facilityCerts.facility.id,
        jobBoardAttributeId: attr.id,
        status: status,
      });
    }
  }

  formatDate(date, format = 'MM/DD/YYYY') {
    if (!date) return null;
    return this.momentService.formateDate(date, format);
  }

  assignCertificates(facility) {
    this.certsPage = 0;
    this.facilityCerts.facility = facility;
    this.facilityCerts.certifications = facility.certifications;
  }

  pageCerts(increment: number) {
    if (this.certsPage + increment >= 0) {
      this.certsPage += increment;
    }
  }

  saveCerts(useBatchApi: boolean = false) {
    if (useBatchApi) {
      // Get ALL facilities from the form
      const allFacilities = this.ownerInfoForm.get('facility_').value;

      // Payload for ALL facilities
      const payload = {
        ownerId: this.id,
        attributes: []
      };

      // For each facility, add its certifications
      allFacilities.forEach(facilityGroup => {
        facilityGroup.indifacility.forEach(facility => {
          // Only add certifications that are checked/updated
          this.facilityCerts.certifications.forEach(cert => {
            if (cert.status) { // Only send active certifications
              payload.attributes.push({
                jobBoardAttributeId: cert.jobBoardAttributeId,
                facilityId: facility.id || 0,
                status: cert.status
              });
            }
          });
        });
      });

      this.jobpointeService.create['employee_job_board_attributes_batch'](payload).subscribe(
        res => {
          if (res.success) {
            this.toastService.showToast('Certificates applied to all facilities', 'success');
            this.getCerts();
            this.getOwnerInfo();
          } else {
            this.toastService.showToast('Error applying certificates', 'error');
          }
        },
        err => {
          this.toastService.showToast('Error applying certificates', 'error');
        }
      );
    } else {
      // single facility implementation
      this.jobpointeService.create['employee_job_board_attributes'](this.facilityCerts.certifications).subscribe(
        res => {
          if (res.success) {
            this.toastService.showToast('Certificates saved successfully', 'success');
            this.facilityCerts.certifications = res.attributes;
            this.getCerts();
          } else {
            this.toastService.showToast('Error saving certificates', 'error');
          }
        },
        err => {
          this.toastService.showToast('Error saving certificates', 'error');
        }
      );
    }
  }

  searchCerts(event) {
    if (!event.target.value) {
      this.getCerts();
      return;
    }
    this.certificates = this.certificates.filter(c => c.name.toLowerCase().includes(event.target.value.toLowerCase()));
  }

  loadDatePicker(className = null, altField = null) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    if (className != null) {
      s.text = `loadDatePicker('` + className + `','` + altField + `');`;
    } else {
      s.text = `loadDatePicker()`;
    }
    this.renderer2.appendChild(this._document.body, s);
  }

  // Add form parameter in group
  addAdditionalInfoSameEditTime(facility: any, data = null, is_duplicate = false) {
    /* Add new requests to existing dates */ //debugger
    let group;

    if (data != null && !is_duplicate) {
      //If data exist, set data in fields
      group = this.formBuilder.group({
        facility_name: [data.facility_name],
        street_address: [data.street_address],
        certifications: [data.certifications],
        apartment: [data.apartment],
        city: [data.city],
        state: [data.state],
        zipcode: [data.zipcode],
        code: [data.code],
        id: [data.id],
      });

      facility.push(group);
    } else {
      //To duplicate facility without id
      if (is_duplicate && data != '') {
        group = this.formBuilder.group({
          facility_name: [data.facility_name],
          street_address: [data.street_address, Validators.required],
          city: [data.city, Validators.required],
          state: [data.state, Validators.required],
          zipcode: [data.zipcode, Validators.required],
          code: [data.code],
          apartment: [data.apartment],
          id: [''],
        });
      } else {
        //To create new facility in view
        group = this.formBuilder.group({
          facility_name: [''],
          street_address: ['', Validators.required],
          apartment: [''],
          city: ['', Validators.required],
          state: ['', Validators.required],
          zipcode: ['', Validators.required],
          code: [''],
          id: [''],
        });
      }

      facility.push(group);
    }
    setTimeout(() => {
      this.loadSelect2();
    }, 200);
  }

  getCerts() {
    this.jobpointeService.read['job_board_attributes']({}).subscribe(res => {
      this.certificates = res.data.filter(attribute => attribute.status === true);
    });
  }

  //To get specific owner data
  getOwnerInfo() {
    this.ownerInfoService.getOwnerFacilityInfoById(this.id).subscribe(
      res => this.onSuccess(res),
      error => this.onError(error),
    );
  }

  //On success of api call
  onSuccess(result) {
    if (result) {
      if (result.data) {
        this.ownerName = result.data.owner_name;
        this.projectIndustryType = result.data.project_industry_id;
        this.initializeForms(result.data.facility);
        this.loaderService.hideLoader();
      } else {
        this.noDataMsg = result.errors;
      }
    }
  }

  //On error of api call
  onError(error) {}

  //To submit owner info
  submitOwnerInfo(formOwnerInfo, ownerInfo) {
    if (formOwnerInfo.invalid) {
    } else {
      let item,
        detail,
        data = {},
        owner_id;

      //Owner info data loop
      for (item of ownerInfo) {
        if (item != null) {
          this.ownerInfoForForm = [];
          //Push Each ownerInfo data object using loop
          for (detail of item.indifacility) {
            this.ownerInfoForForm.push({
              facility_name: detail.facility_name,
              street_address: detail.street_address,
              apartment: detail.apartment,
              city: detail.city,
              state: detail.state,
              zipcode: detail.zipcode,
              code: detail.code,
              id: detail.id,
            });
          }
        }
      }

      //create owner info data object
      data['owner_name'] = this.ownerName;
      data['project_industry_id'] = this.projectIndustryType;
      data['edit'] = [];
      data['add'] = [];
      for (let i = 0; i < this.ownerInfoForForm.length; i++) {
        if (
          this.ownerInfoForForm[i]['id'] != '' &&
          this.ownerInfoForForm[i]['id'] != '0' &&
          this.ownerInfoForForm[i]['id'] != undefined
        ) {
          data['edit'][i] = {};
          data['edit'][i]['facility_name'] = this.ownerInfoForForm[i]['facility_name'];
          data['edit'][i]['street_address'] = this.ownerInfoForForm[i]['street_address'];
          data['edit'][i]['apartment'] = this.ownerInfoForForm[i]['apartment'];
          data['edit'][i]['city'] = this.ownerInfoForForm[i]['city'];
          data['edit'][i]['state'] = this.ownerInfoForForm[i]['state'];
          data['edit'][i]['zipcode'] = this.ownerInfoForForm[i]['zipcode'];
          data['edit'][i]['code'] = this.ownerInfoForForm[i]['code'];
          data['edit'][i]['owner_id'] = this.ownerInfoForForm[i]['owner_id'];
          data['edit'][i]['id'] = this.ownerInfoForForm[i]['id'];
        } else {
          let add = {
            facility_name: this.ownerInfoForForm[i]['facility_name'],
            street_address: this.ownerInfoForForm[i]['street_address'],
            apartment: this.ownerInfoForForm[i]['apartment'],
            city: this.ownerInfoForForm[i]['city'],
            state: this.ownerInfoForForm[i]['state'],
            code: this.ownerInfoForForm[i]['code'],
            zipcode: this.ownerInfoForForm[i]['zipcode'],
          };
          data['add'].push(add);
        }
      }

      if (this.id == null) {
        this.ownerInfoService.addOwnerFacilityInfo(data).subscribe(
          res => this.onOwnerAddUpdateSuccess(res),
          error => this.onOwnerAddUpareError(error),
        );
      } else {
        this.ownerInfoService.updateOwnerFacilityInfo(this.id, data).subscribe(
          res => this.onOwnerAddUpdateSuccess(res),
          error => this.onOwnerAddUpareError(error),
        );
      }
    }
  }

  //On success of api call
  onOwnerAddUpdateSuccess(result) {
    if (result) {
      if (result.data) {
        this.router.navigate(['/owner_info']);
      }
    }
  }

  //On error of api call
  onOwnerAddUpareError(error) {}

  //To delete facility based on id
  deleteFacility(facilityRecord, id, i, j) {
    if (id != '') {
      this.ownerInfoService.deleteOwnerFacilityInfo(id).subscribe(
        res => this.onDeleteSuccess(res),
        error => this.onDeleteError(error),
      );
    } else {
      facilityRecord.controls.indifacility.removeAt(j);
    }
  }

  //On success of delete api call
  onDeleteSuccess(result) {
    if (result) {
      if (result.data) {
        this.getOwnerInfo();
      }
    }
  }

  //On error of delete api call
  onDeleteError(error) {}

  //To get all states data
  getStates() {
    this.statesServices.getStates().subscribe(
      res => this.onStatesSuccess(res),
      error => this.onStatesError(error),
    );
  }

  //On success of states api call
  onStatesSuccess(result) {
    if (result) {
      if (result.data) {
        this.statesData = result.data;
      } else {
        this.noDataMsg = result.errors;
      }
    }
  }

  //On error of states api call
  onStatesError(error) {}

  setDataToGroupControl(formGroupArray, field, value) {
    formGroupArray.get(field).setValue(value);
  }

  //To get all project industry
  getProjectIndustry() {
    //Service call to get all project industry data
    this.projectIndustryService.getProjectIndustry().subscribe(
      res => this.onProjectIndustrySuccess(res),
      error => this.onProjectIndustryError(error),
    );
  }

  //On success of project industry api call
  onProjectIndustrySuccess(result) {
    if (result) {
      if (result.data) {
        this.projectIndustryData = result.data;
      }
    }
  }

  //On error of project industry api call
  onProjectIndustryError(error) {}
  setProjectIndustryData(value) {
    this.projectIndustryType = value;
  }

}
